"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddressInfo = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var AddressInfo = function AddressInfo(props) {
  var _product$address, _product$address$city;
  var product = props.product;
  return (_product$address = product.address) !== null && _product$address !== void 0 && _product$address.city ? /*#__PURE__*/_react.default.createElement(_core.Box, {
    display: "flex",
    alignItems: "flex-start"
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    marginRight: 0.25
  }, /*#__PURE__*/_react.default.createElement(_core.Icon, {
    fontSize: "small"
  }, "room")), /*#__PURE__*/_react.default.createElement(_core.Typography, null, typeof product.address.city === "string" ? product.address.city : (_product$address$city = product.address.city) === null || _product$address$city === void 0 ? void 0 : _product$address$city.name)) : null;
};
exports.AddressInfo = AddressInfo;